/**
 * 榛果 API 的一些 consts
 */

export const WWW_SOURCE_TYPE = 7;

export const ExceptionTypes = {
  NullError: "NullError",
  TimeoutError: "TimeoutError",
  HttpError: "HttpError",
  WrongBodyTypeError: "WrongBodyTypeError",
  BizError: "BizError",
  NetworkError: "NetworkError",
  UnknownError: "UnknownError",
};

export const BizCodes = {
  BAD_PARAMETER: 301,
  UNAUTHORIZED: 401,
};
